export default {
  prod: {
    baseAPI: process.env.VUE_APP_BASE_API
  },
  dev: {
    baseAPI: process.env.VUE_APP_BASE_API_DEV
  }
}
